import copy from 'copy-to-clipboard'

const copyTextClipboard = async (element) => {
  const selectComponent = document.querySelector(element)
  const copyTextElement = selectComponent.value

  copy(copyTextElement)
}

export default copyTextClipboard
